<template>
	<div>

		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_2 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>

		<!--<div-->
		<!--	:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"-->
		<!--	class="my-4"-->
		<!--&gt;</div>-->

		<!--<v-row class="mb-5 font-weight-medium">-->
		<!--	<v-col>-->
		<!--		<div v-html="faseWithStati.descrizione"></div>-->
		<!--	</v-col>-->
		<!--</v-row>-->

		<v-sheet
			rounded
			color="primary"
			class="my-5 px-4 text-h6"
		>
			<span class="tertiary--text">
				Dati Pratica
			</span>
		</v-sheet>

		<v-row>
			<v-col cols="6">
				<v-badge
					:value="praticaDiff.includes('ragione_sociale')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.ragione_sociale"
						@input="pratica.ragione_sociale = $event !== '' ? $event : null"
						label="Ragione Sociale"
						outlined
						dense
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('partita_iva_codice_fiscale')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.partita_iva_codice_fiscale"
						@input="pratica.partita_iva_codice_fiscale = $event !== '' ? $event : null"
						label="Partita IVA / Codice Fiscale"
						outlined
						dense
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
						:hint="isAccountManager && pratica.partita_iva_codice_fiscale_univoco === false
							? 'Attenzione: questo valore è presente anche nelle pratiche: ' + pratica.custom_ids_pratiche_con_stessa_partita_iva.join(', ')
							: ''"
						:persistent-hint="isAccountManager && pratica.partita_iva_codice_fiscale_univoco === false"
					></v-text-field>
          <!-- :error="pratica.partita_iva_codice_fiscale_univoco === false" -->
				</v-badge>
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('codice_identificativo')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.codice_identificativo"
						@input="pratica.codice_identificativo = $event !== '' ? $event : null"
						label="Codice identificativo"
						outlined
						dense
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
						:rules="[mixin_rules.codice_identificativo]"
					></v-text-field>
				</v-badge>
			</v-col>
			<v-col cols="6">
				<v-badge
					:value="praticaDiff.includes('codice_ditta')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.codice_ditta"
						@input="pratica.codice_ditta = $event !== '' ? $event : null"
						label="Codice Ditta"
						outlined
						dense
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('regione')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-select
						v-model="pratica.regione"
						label="Regione"
						:items="regioniItems"
						outlined
						dense
						hide-details
						clearable
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-select>
				</v-badge>
			</v-col>
			<v-col cols="6">
				<v-badge
					:value="praticaDiff.includes('asse_di_finanziamento_id')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-select
						v-model="pratica.asse_di_finanziamento_id"
						label="Asse di Finanziamento"
						:items="asseDiFinanziamentoItems"
						item-text="nome"
						item-value="id"
						:loading="isLoadingAsseDiFinanziamentoItems"
						outlined
						dense
						hide-details
						clearable
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-select>
				</v-badge>
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('agevolazione_richiesta')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.agevolazione_richiesta"
						@input="pratica.agevolazione_richiesta = $event !== '' ? $event : null"
						label="Importo Agevolazione"
						outlined
						dense
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
						:rules="[mixin_rules.max_7_interi_separati_da_punto_2_decimali_e_virgola_per_i_decimali]"
					></v-text-field>
				</v-badge>
			</v-col>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('pec')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.pec"
						@input="pratica.pec = $event !== '' ? $event : null"
						label="PEC primaria dell'azienda associata alla domanda"
						outlined
						dense
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
						:rules="[mixin_rules.email]"
					></v-text-field>
				</v-badge>
			</v-col>
		</v-row>

		<v-row class="mt-0">
			<v-col class="d-flex align-center">
				<div class="mr-3">
					La PEC primaria dell'azienda associata alla domanda è abilitata a ricevere email ordinarie (ovvero non PEC)?
				</div>
				<v-badge
					:value="praticaDiff.includes('is_pec_abilitata')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-radio-group
						v-model="pratica.is_pec_abilitata"
						class="mt-0"
						row
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
					>
						<v-radio
							label="Si"
							:value="true"
						></v-radio>
						<v-radio
							label="No"
							:value="false"
						></v-radio>
					</v-radio-group>
				</v-badge>
			</v-col>
		</v-row>

		<v-row class="mt-6">
			<v-col cols="6">
				<v-badge
					:value="praticaDiff.includes('numero_di_emergenza')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.numero_di_emergenza"
						@input="pratica.numero_di_emergenza = $event !== '' ? $event : null"
						label="Numero di emergenza"
						outlined
						dense
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
						:rules="[mixin_rules.numero_di_emergenza]"
					>
						<template v-slot:append>
							<v-tooltip
								bottom
								color="primary"
							>
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">
										mdi-help-circle-outline
									</v-icon>
								</template>
								Nel caso si volessero inserire più numeri di emergenza separarli con un trattino (-)
							</v-tooltip>
						</template>
					</v-text-field>
				</v-badge>
			</v-col>
			<v-col v-if="isAccountManager" cols="2">
				<v-badge
					:value="praticaDiff.includes('priorita')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.priorita"
						@input="pratica.priorita = $event !== '' ? parseInt($event) : null"
						label="Priorità"
						outlined
						dense
						hide-details
						type="number"
						min="0"
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:rules="[mixin_rules.min0]"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
		</v-row>

		<template v-if="!isCoordinatore">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Dati Contratto di Servizio
				</span>
			</v-sheet>

			<template v-if="pratica.contratto_di_servizio_id === null">
				Contratto di Servizio non ancora caricato
			</template>

			<template v-else>
				<v-row>
					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('nome')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.nome"
								@input="pratica.contratto_di_servizio.nome = $event !== '' ? $event : null"
								label="Nome"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								autocomplete="none"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('cognome')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.cognome"
								@input="pratica.contratto_di_servizio.cognome = $event !== '' ? $event : null"
								label="Cognome"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								autocomplete="none"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('ragione_sociale')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.ragione_sociale"
								@input="pratica.contratto_di_servizio.ragione_sociale = $event !== '' ? $event : null"
								label="Ragione Sociale"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								autocomplete="none"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('partita_iva')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.partita_iva"
								@input="pratica.contratto_di_servizio.partita_iva = $event !== '' ? $event : null"
								label="P.IVA"
								outlined
								dense
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								autocomplete="none"
								hide-details
							></v-text-field>
						<!-- :rules=[mixin_rules.partita_iva_codice_fiscale] -->
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('codice_fiscale')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.codice_fiscale"
								@input="pratica.contratto_di_servizio.codice_fiscale = $event !== '' ? $event : null"
								label="Codice Fiscale"
								outlined
								dense
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								autocomplete="none"
								hide-details
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('indirizzo_fatturazione')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.indirizzo_fatturazione"
								@input="pratica.contratto_di_servizio.indirizzo_fatturazione = $event !== '' ? $event : null"
								label="Indirizzo di Fatturazione"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								autocomplete="none"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('comune_fatturazione')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-autocomplete
								:value="pratica.contratto_di_servizio.comune_fatturazione"
								@input="pratica.contratto_di_servizio.comune_fatturazione = $event ? $event.comune : null"
								label="Comune di Fatturazione"
								:items="comuni"
								item-value="comune"
								item-text="comune"
								return-object
								:filter="(item, queryText, itemText) => customFilterByProperties(item, queryText, ['comune', 'sigla'])"
								:search-input.sync="cercaComune"
								@change="gestisciAutoCompletamentoPartendoDalComune($event)"
								:loading="isLoadingComuni"
								:disabled="isLoading"
								:readonly="action == 'show' || !isAccountManager"
								:no-data-text="isLoadingComuni ? 'In caricamento..' : (cercaComune == null || cercaComune.length < 2 ? 'Scrivi almeno 2 lettere per cercare' : 'Comune non trovato')"
								:persistent-placeholder="isCliente"
								clearable
								hide-details
								autocomplete="none"
								outlined
								dense
							>
								<template v-slot:item="data">
									{{ data.item.comune }} ({{data.item.sigla}})
								</template>
								<template v-slot:selection="data">
									{{ data.item.comune }}
								</template>
							</v-autocomplete>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('cap_fatturazione')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-select
								v-if="isAccountManager"
								v-show="selezioneCapInCorso"
								ref="caps"
								:value="pratica.contratto_di_servizio.cap_fatturazione"
								@input="pratica.contratto_di_servizio.cap_fatturazione = $event !== '' ? $event : null"
								item-text="codice"
								item-value="codice"
								:items="capsItems"
								label="Seleziona un CAP"
								:readonly="action == 'show'"
								outlined
								dense
								hide-details
							></v-select>
							<v-text-field
								v-show="!selezioneCapInCorso"
								:value="pratica.contratto_di_servizio.cap_fatturazione"
								@input="pratica.contratto_di_servizio.cap_fatturazione = $event !== '' ? $event : null"
								label="CAP di Fatturazione"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:loading="isLoadingAllByComuneId"
								:disabled="isLoading || isLoadingAllByComuneId"
								:persistent-placeholder="isCliente"
								autocomplete="none"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('provincia_fatturazione')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.provincia_fatturazione"
								@input="pratica.contratto_di_servizio.provincia_fatturazione = $event !== '' ? $event : null"
								label="Provincia di Fatturazione"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:loading="isLoadingAllByComuneId"
								:disabled="isLoading || isLoadingAllByComuneId"
								:persistent-placeholder="isCliente"
								autocomplete="none"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('nazione_fatturazione')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.nazione_fatturazione"
								@input="pratica.contratto_di_servizio.nazione_fatturazione = $event !== '' ? $event : null"
								label="Nazione di Fatturazione"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:loading="isLoadingAllByComuneId"
								:disabled="isLoading || isLoadingAllByComuneId"
								:persistent-placeholder="isCliente"
								autocomplete="none"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('telefono')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.telefono"
								@input="pratica.contratto_di_servizio.telefono = $event !== '' ? $event : null"
								label="Telefono"
								outlined
								dense
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								autocomplete="none"
								:rules="[mixin_rules.telefono]"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('pec')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.pec"
								@input="pratica.contratto_di_servizio.pec = $event !== '' ? $event : null"
								label="PEC"
								outlined
								dense
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								autocomplete="none"
								:rules="[mixin_rules.email]"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="6" class="pb-0">
						<v-badge
							:value="contrattoDiServizioDiff.includes('codice_univoco')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-autocomplete
								:value="pratica.contratto_di_servizio.codice_univoco"
								@input="pratica.contratto_di_servizio.codice_univoco = $event !== '' ? $event : null"
								label="Codice Univoco SDI"
								:items="codiciSDI"
								:loading="isLoadingCodiciSDI"
								:disabled="isLoadingCodiciSDI"
								:search-input.sync="searchCodiceUnivoco"
								:persistent-placeholder="isCliente"
								:readonly="action == 'show' || !isAccountManager"
								autocomplete="none"
								clearable
								dense
								outlined
								hide-details
							>
								<template v-slot:append v-if="isAccountManager">
									<v-icon
										color="primary"
										@click="openAggiungiCodiceSDIDialog"
										class="cursor-pointer"
									>
										mdi-plus
									</v-icon>
								</template>
							</v-autocomplete>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('email')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.email"
								@input="pratica.contratto_di_servizio.email = $event !== '' ? $event : null"
								label="Email"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
								autocomplete="none"
								:rules="[mixin_rules.email]"
							></v-text-field>
						</v-badge>
					</v-col>
					<!--<v-col cols="6">-->
					<!--	<v-badge-->
					<!--		:value="contrattoDiServizioDiff.includes('tipo')"-->
					<!--		class="d-block"-->
					<!--		color="info"-->
					<!--		overlap-->
					<!--		right-->
					<!--		icon="mdi-pencil"-->
					<!--	>-->
					<!--		<v-select-->
					<!--			:items="tipiContrattoDiServizioOld"-->
					<!--			v-model="pratica.contratto_di_servizio.tipo"-->
					<!--			label="Tipo"-->
					<!--			outlined-->
					<!--			dense-->
					<!--			hide-details-->
					<!--			clearable-->
					<!--			:readonly="action == 'show' || !isAccountManager"-->
					<!--			:disabled="isLoading"-->
					<!--			:persistent-placeholder="isCliente"-->
					<!--		></v-select>-->
					<!--	</v-badge>-->
					<!--</v-col>-->
					<v-col cols="6">
						<v-badge
							:value="contrattoDiServizioDiff.includes('numero_domande')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.numero_domande"
								@input="pratica.contratto_di_servizio.numero_domande = $event !== '' ? parseInt($event) : null"
								label="Numero Domande"
								type="number"
								min="0"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:rules="[mixin_rules.min0]"
								:persistent-placeholder="isCliente"
								autocomplete="none"
							></v-text-field>
						</v-badge>
					</v-col>

					<v-col cols="12">
						<v-badge
							:value="contrattoDiServizioDiff.includes('tipo_contratto_di_servizio')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-select
								:items="tipiContrattoDiServizio"
								item-text="nome"
								item-value="id"
								v-model="pratica.contratto_di_servizio.tipo_contratto_di_servizio"
								@change="aggiornaTipoContrattoDiServizioId($event)"
								label="Tipo di Contratto di Servizio"
								outlined
								dense
								hide-details
								clearable
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:loading="isLoadingTipiContrattoDiServizio"
								:persistent-placeholder="isCliente"
								return-object
								:rules="[mixin_rules.selectRequired]"
							></v-select>
						</v-badge>
					</v-col>

					<v-col cols="6">
						<v-text-field
							:value="pratica.contratto_di_servizio?.tipo_contratto_di_servizio?.tipo_pagamento"
							label="Modalità di Pagamento"
							outlined
							dense
							hide-details
							readonly
							:persistent-placeholder="isCliente"
						></v-text-field>
					</v-col>

					<v-col
						v-if="isAccountManager"
						cols="6"
					>
						<v-badge
							:value="contrattoDiServizioDiff.includes('tipo_erogazione_bonus')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-select
								v-model="pratica.contratto_di_servizio.tipo_erogazione_bonus"
								label="Modalità di Erogazione Bonus"
								:items="tipiErogazioneBonus"
								outlined
								dense
								hide-details
								:readonly="action == 'show'"
								:disabled="isLoading"
							></v-select>
						</v-badge>
					</v-col>

					<v-col cols="6" v-if="isAccountManager">
						<v-text-field
							:value="pratica.accordo.importo_totale_bonus_esiti_provvisori"
							label="Imponibile Totale Bonus Esiti Provvisori"
							outlined
							dense
							hide-details
							readonly
							type="number"
						></v-text-field>
					</v-col>

					<v-col cols="6" v-if="isAccountManager">
						<v-text-field
							:value="pratica.accordo.importo_totale_bonus_esiti_definitivi"
							label="Imponibile Totale Bonus Esiti Definitivi"
							outlined
							dense
							hide-details
							readonly
							type="number"
						></v-text-field>
					</v-col>
				</v-row>
			</template>
		</template>

		<template v-if="isAccountManager">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
					<span class="tertiary--text">
						Creditsafe
					</span>
			</v-sheet>

			<template v-if="pratica.contratto_di_servizio_id === null">
				Contratto di Servizio non ancora caricato
			</template>

			<template v-else>
				<v-row class="mt-6">
					<v-col>
						<v-badge
							:value="contrattoDiServizioDiff.includes('punteggio_di_rischio')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.punteggio_di_rischio"
								@input="pratica.contratto_di_servizio.punteggio_di_rischio = $event !== '' ? $event : null"
								label="Punteggio di Rischio"
								outlined
								dense
								hide-details
								:readonly="action == 'show'"
								:disabled="isLoading"
							></v-text-field>
						</v-badge>
					</v-col>
					<v-col>
						<v-badge
							:value="contrattoDiServizioDiff.includes('score_internazionale')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.score_internazionale"
								@input="pratica.contratto_di_servizio.score_internazionale = $event !== '' ? $event : null"
								label="Score Internazionale"
								outlined
								dense
								hide-details
								:readonly="action == 'show'"
								:disabled="isLoading"
							></v-text-field>
						</v-badge>
					</v-col>
				</v-row>

				<v-row>
					<v-col>
						<template v-if="action == 'store' || action == 'edit'">
							<v-badge
								:value="haveFilesBeenModified.report"
								class="d-block"
								color="info"
								overlap
								right
								icon="mdi-pencil"
							>
								<v-file-input
									v-model="files.report"
									label="Report"
									hide-details
									outlined
									dense
									clearable
									accept=".pdf"
									truncate-length="120"
									@change="setFileChanged(files.report, 'report')"
									@click:clear="pratica.contratto_di_servizio.path_report = null"
									:loading="isLoadingReport"
									:disabled="isLoading"
								>
									<template v-slot:append>
										<template v-if="pratica.contratto_di_servizio.path_report !== null && !isLoadingReport">
											<v-progress-circular
												v-if="downloadingReport"
												size="24"
												width="3"
												color="primary"
												indeterminate
											></v-progress-circular>
											<v-icon
												v-else
												class="ml-3"
												@click="download(pratica.contratto_di_servizio.path_report, 'report')"
											>
												mdi-tray-arrow-down
											</v-icon>
										</template>
										<v-icon
											v-if="files.report !== null"
											class="ml-3"
											@click="viewFileInBrowser(files.report)"
										>
											mdi-eye-outline
										</v-icon>
									</template>
								</v-file-input>
							</v-badge>
						</template>
						<template v-else-if="action == 'show'">
							<v-text-field
								:value="getFileNameFromPath(pratica.contratto_di_servizio.path_report)"
								label="Modulo Codice Click Day"
								hide-details
								outlined
								dense
								readonly
							>
								<template
									v-slot:append
									v-if="pratica.contratto_di_servizio.path_report !== null"
								>
									<template>
										<v-progress-circular
											v-if="downloadingReport"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.contratto_di_servizio.path_report, 'report')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
									<template>
										<v-progress-circular
											v-if="isGettingFile.report"
											size="24"
											width="3"
											color="primary"
											indeterminate
											class="ml-3"
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="getFileAndViewInBrowser(pratica.contratto_di_servizio.path_report, 'report')"
										>
											mdi-eye-outline
										</v-icon>
									</template>
								</template>
							</v-text-field>
						</template>
					</v-col>
				</v-row>
			</template>
		</template>

		<template v-if="pratica.id_stato_fase_2 == 121">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Altro
				</span>
			</v-sheet>

			<v-row>
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('anteprima_importo_da_fatturare')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.anteprima_importo_da_fatturare"
							@input="pratica.anteprima_importo_da_fatturare = $event !== '' ? $event : null"
							label="Anteprima Imponibile da Fatturare in Caso di Vittoria"
							outlined
							dense
							:readonly="action == 'show' || !isAccountManager"
							:disabled="isLoading"
							:persistent-placeholder="isCliente"
							type="number"
							min="0"
							:rules="[mixin_rules.min0]"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>

			<v-row v-if="isAccountManager">
				<v-col cols="6">
					<v-btn
						color="secondary"
						@click="calcoloAutomaticoImporti('anteprima_importo_da_fatturare')"
						:disabled="isLoading
								|| pratica.contratto_di_servizio_id === null
								|| pratica.contratto_di_servizio?.tipo_contratto_di_servizio_id === null"
					>
						Calcola anteprima imponibile
					</v-btn>
				</v-col>
				<v-col cols="12">
					<p
						v-if="pratica.contratto_di_servizio_id === null || pratica.contratto_di_servizio?.tipo_contratto_di_servizio_id === null"
						:style="`color:${$vuetify.theme.currentTheme.warning}`"
					>
						Il bottone per il calcolo automatico dell'imponibile non è disponibile,<br>
						assicurati che sia stato associato un Contratto di Servizio e sia stato scelto il Tipo di Contratto di Servizio
					</p>
				</v-col>
			</v-row>
		</template>

		<v-dialog
			v-model="aggiungiCodiceSDIDialog"
			:key="aggiungiCodiceSDIKey"
			persistent
			max-width="600"
			scrollable
		>
			<aggiungi-codice-sdi
				@close="aggiungiCodiceSDIDialog = false"
				@codice-sdi-aggiunto="handleCodiceSDIAggiunto($event)"
			></aggiungi-codice-sdi>
		</v-dialog>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { eventBus } from "@/event-bus";
import axios from "axios";
const mime = require('mime');
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'contrattoDiServizioDiff', 'haveFilesBeenModified', 'reportFile'],
	data() {
		return {
			isSettingPratica: false,
			pratica: {},
			isLoadingAsseDiFinanziamentoItems: false,
			asseDiFinanziamentoItems: [],
			menuDataDiNascita: false,

			isLoadingAll: false, // comune, provincia e nazione di fatturazione

			isLoadingCodiciSDI: false,
			codiciSDI: [],
			searchCodiceUnivoco: '',

			files: {
				report: null
			},
			isLoadingReport: false,
			downloadingReport: false,

			isUpdatingFromCodiceUnivoco: false,
			isUpdatingFromSearch: false,

			aggiungiCodiceSDIDialog: false,
			aggiungiCodiceSDIKey: 0,

			getComuniTimeout: null,
			comuni: [],
			isLoadingComuni: false,
			cercaComune: null,
			capsItems: [],
			selezioneCapInCorso: false,
			isLoadingAllByComuneId: false,
		}
	},

	created() {
		this.isSettingPratica = true;
		this.pratica = this.value;
		this.isSettingPratica = false;

		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_2 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_2 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_2',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_2');
		}

		this.getAsseDiFinanziamentoItems();

		/**
		 * Caricamento iniziale del file Report:
		 * - Se reportFile è già valorizzato (passato dal padre perché selezionato in Fase 9),
		 *   il watcher con immediate:true lo ha già assegnato a files.report, quindi non serve scaricare.
		 * - Se reportFile è null/undefined, significa che nessun file è stato selezionato
		 *   in un'altra fase, quindi scarica dal server se esiste un path salvato.
		 */
		if (this.reportFile === null || this.reportFile === undefined) {
			if (this.pratica.contratto_di_servizio.path_report !== null && this.action != 'show' && this.isAccountManager) {
				this.getReport();
			}
		}

		this.getCodiciSDI();

		if (this.pratica.contratto_di_servizio.comune_fatturazione !== null) {
			this.getComuni(this.pratica.contratto_di_servizio.comune_fatturazione);
		}
		this.$watch('searchProvincia', (newVal) => {
			clearTimeout(this.getProvinceTimeout);
			this.getProvinceTimeout = setTimeout(function () {
				if (newVal != null && newVal.length >= 2) this.getProvince(newVal);
			}.bind(this), 500);
		});
	},

	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore',
			bando: 'shared/bando',
			tipiContrattoDiServizio: 'contrattoDiServizio/tipiContrattoDiServizio',
			isLoadingTipiContrattoDiServizio: 'contrattoDiServizio/isLoadingTipiContrattoDiServizio'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingAsseDiFinanziamentoItems
				|| this.isLoadingTipiContrattoDiServizio
				|| this.isLoadingCodiciSDI;
		}
	},

	watch: {
		/**
		 * Watcher per sincronizzare il file Report tra Fase 2 e Fase 9.
		 *
		 * Il file Report è presente sia nella Fase 2 che nella Fase 9, e deve essere sincronizzato.
		 * Il componente padre (StoreEditViewPratica) mantiene la copia "master" in files.report
		 * e la passa come prop `reportFile` a entrambe le fasi.
		 *
		 * - `immediate: true`: esegue l'handler subito al mount del componente,
		 *   così se il file è già stato selezionato nell'altra fase, viene mostrato immediatamente.
		 * - Quando l'altra fase modifica il file e il padre aggiorna la prop, questo watcher
		 *   aggiorna automaticamente files.report locale.
		 */
		reportFile: {
			handler(newVal) {
				if (newVal !== undefined) {
					this.files.report = newVal;
				}
			},
			immediate: true
		},
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},

		'cercaComune': function (newVal) {
			clearTimeout(this.getComuniTimeout);
			this.getComuniTimeout = setTimeout(function () {
				if (newVal != null && newVal.length >= 2) this.getComuni(newVal);
			}.bind(this), 500);
		},
		'pratica.contratto_di_servizio.comune_fatturazione': function (newVal) {
			if (newVal === null) {
				this.selezioneCapInCorso = false;
			}
		},
	},

	methods: {
		aggiornaTipoContrattoDiServizioId(tipoContrattoDiServizio) {
			this.pratica.contratto_di_servizio.tipo_contratto_di_servizio_id = tipoContrattoDiServizio ? tipoContrattoDiServizio.id : null;
		},
		getAsseDiFinanziamentoItems() {
			this.isLoadingAsseDiFinanziamentoItems = true;
			axios.get('/api/assi-di-finanziamento', {
				params: {
					bando_id: this.bando.id
				}
			})
				.then(response => {
					this.asseDiFinanziamentoItems = response.data;
				})
				.finally(() => {
					this.isLoadingAsseDiFinanziamentoItems = false;
				})
		},
		/**
		 * Marca un file come modificato e notifica il padre se è il Report.
		 *
		 * @param {File} file - Il file selezionato
		 * @param {string} key - La chiave del file (es. 'report')
		 *
		 * Per il file Report, emette l'evento 'report-changed' che il padre
		 * (StoreEditViewPratica) intercetta per incrementare fase9key,
		 * forzando il re-render della Fase 9 con il nuovo file.
		 */
		setFileChanged(file, key) {
			if (file !== null && !this.isLoading) {
				file.changed = true;
				if (key === 'report') {
					this.$emit('report-changed');
				}
			}
		},
		async getReport() {
			this.isLoadingReport = true;
			this.files.report = await this.getFile(this.pratica.contratto_di_servizio.path_report);
			this.files.report.changed = false;
			this.isLoadingReport = false;
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'report') this.downloadingReport = true;
			axios.post('/api/storage/download',
				{
					path: path
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'report') this.downloadingReport = false;
				})
		},
		getCodiciSDI() {
			this.isLoadingCodiciSDI = true;

			axios.get('/api/codici-sdi')
				.then(response => {
					this.codiciSDI = response.data;
				})
				.finally(() => {
					this.isLoadingCodiciSDI = false;
				})
		},
		openAggiungiCodiceSDIDialog() {
			this.aggiungiCodiceSDIKey++;
			this.aggiungiCodiceSDIDialog = true;
		},
		handleCodiceSDIAggiunto(codice) {
			this.pratica.contratto_di_servizio.codice_univoco = codice.toString();
			this.searchCodiceUnivoco = codice.toString();
			this.getCodiciSDI();
		},
		getComuni(toSearch = null) {
			this.isLoadingComuni = true;
			this.comuni = [];

			let params = {};
			if (toSearch != null) params.search = toSearch;

			axios.get('/api/comuni', {
				params: params
			})
				.then(response => {
					this.comuni = response.data.map(comune => {
						return {
							comune: comune.nome,
							sigla: comune.sigla,
							id: comune.id
						}
					});
				})
				.finally(() => {
					this.isLoadingComuni = false;
				});
		},
		gestisciAutoCompletamentoPartendoDalComune(comuneObj) {
			if (comuneObj !== null) {
				this.getAllByComuneId(comuneObj.id);
			}
			else {
				this.pratica.contratto_di_servizio.cap_fatturazione = null;
				this.pratica.contratto_di_servizio.provincia_fatturazione = null;
				this.pratica.contratto_di_servizio.sigla_provincia_fatturazione = null;
				this.pratica.contratto_di_servizio.nazione_fatturazione = null;
			}

		},
		getAllByComuneId(comuneId) {
			this.isLoadingAllByComuneId = true;
			this.selezioneCapInCorso = false;

			axios.get('/api/all-by-comune-id', {
				params: {
					comune_id: comuneId
				}
			})
				.then(response => {
					this.pratica.contratto_di_servizio.provincia_fatturazione = response.data.provincia.nome;
					this.pratica.contratto_di_servizio.sigla_provincia_fatturazione = response.data.provincia.sigla;
					this.pratica.contratto_di_servizio.nazione_fatturazione = response.data.provincia.regione.nazione.nome;

					this.capsItems = response.data.caps;

					if (this.capsItems.length == 1) {
						this.pratica.contratto_di_servizio.cap_fatturazione = this.capsItems[0].codice;
					}
					else {
						this.pratica.contratto_di_servizio.cap_fatturazione = null;
						this.selezioneCapInCorso = true;
					}
				})
				.finally(() => {
					this.isLoadingAllByComuneId = false;
				})
		},
		calcoloAutomaticoImporti(key) {
			axios.post('/api/tipi-contratto-di-servizio/calcolo-importi', {
				pratica_id: this.pratica.id,
				tipo_contratto_di_servizio_id: this.pratica.contratto_di_servizio.tipo_contratto_di_servizio_id
			})
				.then(response => {
					if (key == 'anteprima_importo_da_fatturare') {
						this.pratica.anteprima_importo_da_fatturare = response.data.importo_fattura;
					}
				})
		}
	}

}
</script>

<style scoped lang="scss">
	//::v-deep .codice-sdi-combobox input {
	//	text-transform: uppercase;
	//}
</style>
